var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowWrapperLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.98 0H3.68C1.65 0 0 1.65 0 3.69V45.94C0 47.98 1.64 49.63 3.67 49.63H31.25C33.28 49.63 34.92 47.98 34.92 45.97V12.87L23.9 0H22.98ZM22.06 1.84H3.67C2.66 1.84 1.84 2.68 1.84 3.67V45.97C1.84 46.98 2.68 47.8 3.68 47.8H31.26C32.28 47.8 33.1 46.98 33.1 45.97V14.71H25.74C23.71 14.71 22.07 13.08 22.07 11.02V1.84H22.06ZM23.9 2.76V11.02C23.9 12.04 24.73 12.87 25.73 12.87H32.54L23.9 2.76ZM14.71 20.22V22.06H29.42V20.22H14.71ZM5.52 18.38V23.89H11.03V18.38H5.52ZM7.36 20.22V22.06H9.2V20.22H7.36ZM5.52 27.57V33.08H11.03V27.57H5.52ZM7.36 29.41V31.25H9.2V29.41H7.36ZM14.71 29.41V31.25H29.42V29.41H14.71ZM5.52 36.76V42.27H11.03V36.76H5.52ZM7.36 38.6V40.44H9.2V38.6H7.36ZM14.71 38.6V40.44H29.42V38.6H14.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowWrapperLogoWhite);
export default __webpack_public_path__ + "static/media/snow-wrapper-logo-white.bdaa6ffe62e44a4f12a141202cb6019f.svg";
export { ForwardRef as ReactComponent };